import React from 'react';
import PropTypes from 'prop-types';
import getTrainNameWithNumber from '../utils/ltsCardDetailsUtils';

export function TrainNameNumberDesktop(props) {
  const { trainNumber, trainName } = props;
  return (
    <div className="makeFlex hrtlCenter appendBottom25">
      <span className="appendRight10 railSeoSprite trainIcon--purple" />
      <p className="makeFlex column">
        <span className="font24 latoHeavy blackText">{trainNumber}</span>
        <span className="font16">{getTrainNameWithNumber(trainName, trainNumber)}</span>
      </p>
    </div>
  );
}

TrainNameNumberDesktop.propTypes = {
  trainNumber: PropTypes.string,
  trainName: PropTypes.string
};

export default TrainNameNumberDesktop;
